import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ConfigurazioneStagione, Spettacolo } from '../../shared/interface';
import { environment } from '../../../environments/environment';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../services/storage.service';
import { ImagePipe } from '../../shared/image.pipe';

@Component({
  selector: 'app-stagione',
  templateUrl: './stagione.component.html',
  styleUrl: './stagione.component.css'
})
export class StagioneComponent implements OnInit {

  constructor(private apiService: ApiService, private storageService: StorageService, private datePipe: DatePipe, private imagePipe: ImagePipe) { }  

  card: boolean = true;
  all: boolean = false;

  conf_stagione?: ConfigurazioneStagione;
  spettacoli: Spettacolo[] = [];
  spettacoli_filtrati: Spettacolo[] = [];
  spettacoli_paginazione: Spettacolo[] = [];

  pagina: number = 0;
  ricerca: string = ''

  caricamento: boolean = false;

  ngOnInit(): void {

    addEventListener("mousemove", (event) => {
      let bubble = document.getElementById('bubble');
      if (bubble) {
        let y = event.pageY;
        let x = event.pageX;
        bubble.style.top = y + 'px';
        bubble.style.left = x + 'px';
      }
    });

    this.caricamento = true;

    // Recupero la conf della stagione
    this.apiService.getConfigurazioneStagione().subscribe({
      next: (data) => this.conf_stagione = data,
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        this.apiService.getSpettacoli().subscribe({
          next: (data) => this.spettacoli = [...data],
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            this.spettacoli_filtrati = [...this.spettacoli.filter(spettacolo => {
              const date = spettacolo.calendario!.length > 0 && spettacolo.calendario!.length <= 1 ? this.datePipe.transform(spettacolo.calendario![0].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![0].orario : (spettacolo.calendario!.length == 0 ? this.datePipe.transform(spettacolo!.al, 'yyyy-MM-dd') : this.datePipe.transform(spettacolo.calendario![spettacolo.calendario!.length - 1].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![spettacolo.calendario!.length - 1].orario)
              const time = new Date(date || '').getTime() - new Date().getTime();
              if (time > 300000)
                return spettacolo;
              else
                return null;
            })];

            let filtri: {pagina: number} | null = this.storageService.getFiltri();
            this.pagina = filtri?.pagina ? filtri.pagina : 0;

            this.caricamento = false;
            this.updatePaginatedItems(this.pagina, 12);
          }
        })

      }
    })

  }

  onPageChange(event: any, element: HTMLElement) {
    this.storageService.setFiltri({ pagina: event.first })
    this.updatePaginatedItems(event.first, event.rows);
    element.scrollIntoView({ behavior: 'smooth' });
  }

  updatePaginatedItems(startIndex: number, endIndex: number) {
    this.spettacoli_paginazione = [...this.spettacoli_filtrati.slice(startIndex, startIndex + endIndex)];
  }

  onCerca(ricerca: any) {

    this.spettacoli_filtrati = this.all ? [...this.spettacoli.filter(spettacolo => spettacolo.spettacolo.toLowerCase().includes(ricerca.toLowerCase()))] : [...this.spettacoli.filter(spettacolo => {
      const date = spettacolo.calendario!.length > 0 && spettacolo.calendario!.length <= 1 ? this.datePipe.transform(spettacolo.calendario![0].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![0].orario : (spettacolo.calendario!.length == 0 ? this.datePipe.transform(spettacolo!.al, 'yyyy-MM-dd') : this.datePipe.transform(spettacolo.calendario![spettacolo.calendario!.length - 1].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![spettacolo.calendario!.length - 1].orario)
      const time = new Date(date || '').getTime() - new Date().getTime();
      if (time > 300000 && spettacolo.spettacolo.toLowerCase().includes(ricerca.toLowerCase()))
        return spettacolo;
      else
        return null;
    })];

    this.updatePaginatedItems(this.pagina, 12)
  }

  onAll() {
    this.all = !this.all;

    this.spettacoli_filtrati = this.all ? [...this.spettacoli.filter(spettacolo => spettacolo.spettacolo.toLowerCase().includes(this.ricerca.toLowerCase()))] : [...this.spettacoli.filter(spettacolo => {
      const date = spettacolo.calendario!.length > 0 && spettacolo.calendario!.length <= 1 ? this.datePipe.transform(spettacolo.calendario![0].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![0].orario : (spettacolo.calendario!.length == 0 ? this.datePipe.transform(spettacolo!.al, 'yyyy-MM-dd') : this.datePipe.transform(spettacolo.calendario![spettacolo.calendario!.length - 1].data, 'yyyy-MM-dd') + " " + spettacolo.calendario![spettacolo.calendario!.length - 1].orario)
      const time = new Date(date || '').getTime() - new Date().getTime();
      if (time > 300000 && spettacolo.spettacolo.toLowerCase().includes(this.ricerca.toLowerCase()))
        return spettacolo;
      else
        return null;
    })]

    this.updatePaginatedItems(this.pagina, 12);
  }

  setBubbleImage(img_box: string) {
    let bubble = document.getElementById('bubble');
    bubble!.style.backgroundImage = 'url("' + (this.imagePipe.transform(img_box + '?type=spettacolo')) + '"), url("../../../assets/images/logo.svg")';
  }  
}
